import { render, staticRenderFns } from "./lowPriceUndistributed.vue?vue&type=template&id=25021a94&scoped=true"
import script from "./lowPriceUndistributed.vue?vue&type=script&lang=js"
export * from "./lowPriceUndistributed.vue?vue&type=script&lang=js"
import style0 from "./lowPriceUndistributed.vue?vue&type=style&index=0&id=25021a94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25021a94",
  null
  
)

export default component.exports